import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Stack } from '@stepstone-genesis/components';
import { EVENT_TYPES } from '@stepstone/events-js';
import { closeModalThunk } from '../../../wrappers/Modal/modalSlice.js';
import { useAppDispatch, useAppSelector } from '../../../hooks.js';
import { givenNameSelector } from '../loginWithLinkedInSlice.js';
import { ImportProfileHeader } from '../ImportProfileHeader/index.js';
import { ImportProfileButtonsContainer } from '../ImportProfileButtonsContainer/index.js';
import { useTrack } from '../../../../tracking/common/hooks/useTrack.js';
import { setActiveView } from '../../../core/wrapperContext/wrapperContextSlice.js';
import { FORM_TYPES } from '../../../../inlineForms.js';
export const LinkedInImportProfileForm = () => {
    const dispatch = useAppDispatch();
    const { trackBtnClick, trackModalComponentVisible } = useTrack('linkedin');
    useEffect(() => {
        (dispatch(setActiveView(FORM_TYPES.LINKEDIN_IMPORT_PROFILE)),
            trackModalComponentVisible());
    }, []);
    const onModalClose = () => {
        trackBtnClick({ uniqueName: 'maybeLater' });
        document.dispatchEvent(new Event(EVENT_TYPES.CANDIDATE_PROFILE_EVENTS.LINKEDIN_IMPORT_PROFILE_MODAL_CLOSED_ON_JOB_AD));
        dispatch(closeModalThunk());
    };
    const givenNameFromSelector = useAppSelector(givenNameSelector);
    const givenName = givenNameFromSelector ? `, ${givenNameFromSelector}` : '';
    return (_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceL'], "data-testid": "linkedin-update-profile-form", mt: "spaceL", children: [_jsx(ImportProfileHeader, { givenName: givenName }), _jsx(ImportProfileButtonsContainer, { onModalClose: onModalClose })] }));
};
//# sourceMappingURL=LinkedInImportProfileForm.js.map